import React from "react"
import { AccountBoundary } from "./boundary"
import { AccountLogOutRedirect } from "./views/logoutRedirect"

export const Logout = (): JSX.Element => (
  <AccountBoundary>
    <AccountLogOutRedirect />
  </AccountBoundary>
)
